import { Component } from '@angular/core';

@Component({
  selector: 'app-reports-start',
  templateUrl: './reports-start.component.html',
  styleUrls: ['./reports-start.component.scss']
})
export class ReportsStartComponent {

}
